<template>
    <div class="navigation">
        <router-link class="nav-item" :to="{name: 'home'}">
            <span class="item-name">Home</span>
        </router-link>
        <router-link class="nav-item" v-if="brand!==undefined"
                     :to="{name: 'models', query: {brandName:  brand}}">
            <span>-</span><span class="item-name">{{brand}}</span>
        </router-link>
        <router-link class="nav-item" v-if="model!==undefined && capacity!==undefined"
                     :to="{name: 'models', query: {brandName:  brand}}">
            <span>-</span><span class="item-name">{{model}}</span>
        </router-link>
        <a class="nav-item" v-if="model!==undefined && capacity==undefined"><span>-</span><span class="item-name">{{model}}</span></a>
        <a class="nav-item" v-if="capacity!==undefined">
            <span>-</span><span class="item-name">{{capacity}}</span>
        </a>

    </div>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    brand: '',
    model: '',
    capacity: ''
  },
  data () {
    return {
      prices: []
    }
  },
  mounted () {

  }
}

</script>

<style scoped>

</style>
